//implement socket configurtion
import { io, Socket } from 'socket.io-client'
import Cookies from 'js-cookie'

let socket: Socket | null = null

export function getSocketDeviceType(
  vendor: string | undefined
): 'WEB' | 'DESKTOP' {
  return vendor === 'W' ? 'WEB' : 'DESKTOP'
}

export function getSocket(): Socket {
  if (!socket) {
    const token = Cookies.get('user_token')
    if (token) {
      socket = io(import.meta.env.VITE_SOCKET_BASE_URL, {
        auth: {
          token: `Bearer ${token}`,
          deviceType: getSocketDeviceType(Cookies.get('v'))
        },
        reconnection: true,
        reconnectionAttempts: 5,
        reconnectionDelay: 3000,
        transports: ['websocket']
      })
    }

    // مدیریت رویدادهای اتصال
    socket?.on('connect', () => {
      console.log('✅ Socket connected:', socket?.id)
    })

    socket?.on('disconnect', (reason) => {
      console.log('⚠️ Socket disconnected:', reason)
    })

    socket?.on('connect_error', (error) => {
      console.error('❌ Connection Error:', error)
    })

    socket?.on('reconnect_attempt', (attempt) => {
      console.log(`🔄 Reconnecting attempt ${attempt}...`)
    })
  }
  return socket as Socket
}

export function disconnectSocket() {
  if (socket) {
    socket.disconnect()
    socket = null
  }
}
